var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIconMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.812,
    height: 105.895,
    viewBox: "0 0 92.812 105.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "orvosi_chat_ikon_mobil",
    transform: "translate(-657.939 -551.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11015",
    d: "M710.463,579.475h9.391V624.3H700.9l14.837,12.836",
    transform: "translate(28.398 18.331)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11016",
    d: "M670.816,591.972v23.56h35.619",
    transform: "translate(7.283 27.104)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11017",
    d: "M694.97,566.205h35.621v44.817H660.439V566.205h18.95l-14.833-12.847",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1062",
    x2: 5.376,
    transform: "translate(693.921 588.964)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1063",
    x2: 5.376,
    transform: "translate(707.118 588.964)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1064",
    x2: 5.376,
    transform: "translate(680.724 588.964)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1065",
    x2: 5.376,
    transform: "translate(709.807 622.514)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1066",
    x2: 5.376,
    transform: "translate(723.003 622.514)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1067",
    x2: 5.376,
    transform: "translate(696.61 622.514)",
    fill: "none",
    stroke: "#1fba9c",
    strokeWidth: 5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconMobile);
export default __webpack_public_path__ + "static/media/ChatIconMobile.b1d919e32f22c373098a8ab9f9976c9c.svg";
export { ForwardRef as ReactComponent };